import img1 from './001.png';
import img2 from './002.png';
import img3 from './003.png';
import img4 from './004.png';
import img5 from './005.png';
import img6 from './006.png';
import img7 from './007.png';

const images = {
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
};

export default images;
